export const state = {
  baseURL: 'https://srv.bfit.fit'
}
